import './AuthStatus.css';

export function AuthStatus (props) {
    return (
        <div className='auth-status' {...props}></div>
    )
}